export const ROOM = { W: 22, D: 14, H: 4.8, EYE: 1.65, PAINT_Y: 1.75 };
export const ALCOVE = { w: 5.2, d: 3.9, h: 3.5, z0: ROOM.D / 2, gap: 3.2 };
export const BENCH_Z = ROOM.D / 2 + 1.55;
export const SIGN = { x: 1.95, z: ROOM.D / 2 + 0.45, rot: Math.atan2(-0.35, -1) };
// the Flipbook's table, on the other side of the Memory Wall alcove's opening, turned toward the hall
export const BOOK = { x: -1.9, z: ROOM.D / 2 + 0.55, rot: Math.PI + 0.3 };
// where a visitor stands to look at the book, and the hall signpost pointing to it
export const BOOK_STAND = { x: BOOK.x + 0.5, z: BOOK.z - 1.7, yaw: Math.atan2(-0.5, 1.7) + Math.PI };
export const BOOK_SIGN = { x: -2.5, z: 4.1, rot: Math.atan2(2.5, -3.1) };

const WALLS = [
  { len: ROOM.W, ox: -ROOM.W / 2, oz: -ROOM.D / 2, tx: 1, tz: 0, nx: 0, nz: 1 },
  { len: ROOM.D, ox: ROOM.W / 2, oz: -ROOM.D / 2, tx: 0, tz: 1, nx: -1, nz: 0 },
  { len: ROOM.W, ox: ROOM.W / 2, oz: ROOM.D / 2, tx: -1, tz: 0, nx: 0, nz: -1 },
  { len: ROOM.D, ox: -ROOM.W / 2, oz: ROOM.D / 2, tx: 0, tz: -1, nx: 1, nz: 0 },
];

function wallCounts(n) {
  const per = WALLS.reduce((s, w) => s + w.len, 0);
  const quotas = WALLS.map((w) => (w.len / per) * n);
  const counts = quotas.map(Math.floor);
  const order = quotas.map((q, i) => [q - counts[i], i]).sort((a, b) => b[0] - a[0]);
  for (let k = 0; k < n - counts.reduce((s, c) => s + c, 0); k++) counts[order[k][1]]++;
  return counts;
}

export function layoutSlots(n) {
  const counts = wallCounts(n);
  const slots = [];
  WALLS.forEach((w, wi) => {
    for (let i = 0; i < counts[wi]; i++) {
      const a = (w.len * (i + 0.5)) / counts[wi];
      slots.push({
        x: w.ox + w.tx * a + w.nx * 0.04,
        z: w.oz + w.tz * a + w.nz * 0.04,
        nx: w.nx,
        nz: w.nz,
        rotY: Math.atan2(w.nx, w.nz),
      });
    }
  });
  return slots;
}

export function paintingSize(aspect) {
  let h = Math.sqrt(3.4 / aspect);
  let w = h * aspect;
  const k = Math.min(1, 2.6 / h, 3.2 / w);
  return { w: w * k, h: h * k };
}
